import React, { useContext } from "react";
import { FieldArray, Formik } from "formik";

import { Label } from "components/Form";
import { Col, Row } from "components/Grid";
import Icon from "components/Icon";

import Colors from "constants/Colors";
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import FunctionHelpers from "utils/src/function-helpers";
import { FitinsurAPI, MessageCenter } from 'utils';

const ListDetail = ({ hasDelete, listDocuments, document, idOperation }) => {
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const loading = useContext(GlobalLoaderContext);
  const mc = new MessageCenter();
  const functionHelpers = new FunctionHelpers();

  fitinsur.setAuthToken(authContext.token);

  function handleRmvAttach(idOperation, idDocument) {
    loading.start();

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestWordingDelAttach(idOperation, idDocument)
      .then(data => data.json())
      .then(resp => {
        if (resp.ret_code !== 200) {
          mc.error(resp.ret_msg_details);
          loading.stop();
          return;
        } else {
          // listDocuments();
        }
      }).catch(err => {
        mc.error("An error happened, please try again: " + err);
        loading.stop();
      });
  };

  return (
    <Formik>
      <FieldArray
        name="listDetail"
        render={() =>
          <span>
            <Row className="align-items-center justify-content-center">
              <Col md={12}>
                <Row md={12}>
                  <Col md={6}>
                    <Row>
                      <Col md={4} style={{ textAlign: 'center', allignItens: 'center' }}>
                        <Label style={{ paddingTop: '1rem' }} textColor={Colors.GRAY[0]}>
                          {document.documentName}
                        </Label>
                      </Col>
                      <Col md={4} style={{ textAlign: 'center' }}>
                        <Label style={{ paddingTop: '1rem' }} textColor={Colors.GRAY[0]}>
                          {document.version}
                        </Label>
                      </Col>
                      <Col md={4} style={{ textAlign: 'center' }}>
                        <Label style={{ paddingTop: '1rem' }} textColor={Colors.GRAY[0]}>
                          {document.documentType}
                        </Label>
                      </Col>
                    </Row>
                  </Col>

                  <Col md={6}>
                    <Row>
                      <Col md={4} style={{ textAlign: 'center' }}>
                        <Label style={{ paddingTop: '1rem' }} textColor={Colors.GRAY[0]}>
                          {document.uploadedBy}
                        </Label>
                      </Col>
                      <Col md={4} style={{ textAlign: 'center' }}>
                        <Label style={{ paddingTop: '1rem' }} textColor={Colors.GRAY[0]}>
                          {document.uploadedDate.replaceAll('-', '/')}
                        </Label>
                      </Col>
                      <Col md={4} style={{ textAlign: 'center' }}>
                        <Row className="align-items-center justify-content-center" style={{ marginLeft: '3rem' }}>
                          <Label style={{ paddingTop: '1rem' }}>
                            <Icon
                              onClick={() => window.open(document.url, '_blank')}
                              name="search"
                              style={icon} />
                          </Label>
                          <Label style={{ paddingTop: '1rem', paddingLeft: '0.5rem' }}>
                            <Icon
                              disabled={!hasDelete}
                              onClick={() => hasDelete && handleRmvAttach(idOperation, document.idDocument)}
                              name="trash"
                              style={!hasDelete ? opacity : null}
                            />
                          </Label>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </span>
        }
      />
    </Formik>

  );
};

const spaceLabel = {
  allignItens: "center",
};

const icon = {
  color: Colors.GRAY[6],
};

const opacity = {
  color: Colors.GRAY[5],
  opacity: 0.5,
  cursor: "not-allowed",
};

const opacityAllowed = {
  color: Colors.GRAY[5],
  opacity: 0.5,
};

export default ListDetail;
